export async function fetchWithCsrf(url, options = {}) {
    try {
        const headers = {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content || '{{ csrf_token() }}',
            'Accept': 'application/json',
            ...(options.headers || {}),
        };

        // If the body is FormData, don’t set Content-Type (browser will set it with boundary)
        if (!(options.body instanceof FormData)) {
            headers['Content-Type'] = headers['Content-Type'] || 'application/json';
            options.body = JSON.stringify(options.body);
        }


        const res = await fetch(url, {
            ...options,
            headers,
        });

        const data = await res.json();

        if (!res.ok) {
            return { error: true, ...data };
        }

        return data;
    } catch (error) {
        console.error("Network error:", error);
        return { error: true, message: error.message };
    }
}

export function toFormData(inputs) {
    let fd = new FormData();
    for (const key in inputs) {
        fd.append(key, inputs[key]);
    }
    return fd;
}

export function toastMessage(message) {
    document.querySelector(".toast #message").textContent = message;
    document.querySelector(".toast").classList.add("opacity-100");
    setTimeout(function() {
        document.querySelector(".toast").classList.remove("opacity-100");
    }, 2500);
}